module.exports = __webpack_public_path__ + "img/liga.01465e82.png";